import React from "react";
import { Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";

const BankHolderName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="accountHolderName"
      label="Bank Holder Name"
      rules={[
        {
          required: true,
          message: "Please input Bank Holder Name",
        },
        {
          whitespace: true,
          message: "Please input Bank Holder Name",
        },
        {
          pattern: /^[A-Za-z]+$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input
        prefix={<UserOutlined className="form-item-icon" />}
        placeholder="Bank Holder Name"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default BankHolderName;
